import React from "react"
import bennyImage from "../../img/bennyQuad.jpg"
import "./introducing.css"

export const Introducing = () => {
  return (
    <div className="introducing">
      <div className="introducing__imgContainer">
        <img src={bennyImage} />
      </div>
      <div className="introducing__textContainer">
        <h4>Hi, ich bin Benny</h4>
        <h2>Ich bin Frontend-Developer aus Leidenschaft.</h2>
        <p>
          Momentan lebe ich gemeinsam mit meiner Freundin und unserem Sohn in
          Zähringen - einem Stadteil Freiburgs.
        </p>
        <p>
          Meine Freizeit verbringe ich am liebsten in meinen "Wanderschläppchen"
          im Schwarzwald, oder bei einer guten Serie vor dem Fernseher.
        </p>
        {/* <h2>Arbeit</h2>
        Mein Geld verdiene ich in einer Web-Agentur als Frontend-Developer. Ich
        liebe es komplexe User Interfaces mit HTML & CSS zu Gestalten. In letzer
        Zeit arbeite ich immer häufiger mit React was mir wahnsinnig Spaß macht.
        <h2>Unnützes Wissen über mich</h2>
        Meine Lieblingssuperhelden sind Iron- und Spider Man. Mir folgte einst
        unser Bürgermeister Martin Horn auf Instagram... er ist mir mitlerweile
        entfolgt 💔. Ich hasse es wenn Arbeitskollegen krank ins Büro kommen
        (schon vor Corona). Ich habe lange Zeit in einem Restauran gearbeitet
        und Christian Streich als Gast gehabt. */}
      </div>
    </div>
  )
}

export default Introducing
